import React from 'react';
import styles from '../../styles.css';
import subCategoriesStyles from './styles.css';
import { default as Indicators } from '../Indicators/index.jsx';

import { isSearchedPhrase } from '../../utils';
import HighlightText from '../../HighlightText.jsx';
import { useTranslation } from 'react-i18next';

export default function SubCategories({
	isSimplifiedView,
	subjectId,
	subCategories,
	nestedListsToShow,
	showNestedLists,
	selectedSubjects,
	onSubjectSelect,
	subjectColor,
	subjectParent,
	queryParams,
	searchPhrase,
	onSubjectChange,
}) {
	const { t } = useTranslation();
	return (
		<div
			className={`${isSimplifiedView ? 'measure-expand-info-menu' : ''} ${subCategoriesStyles.measureExpand} ${
				!nestedListsToShow.includes(subjectId) ? styles.hidden : ''
			}`}
		>
			<div className={subCategoriesStyles.subCategoryGrid}>
				{subCategories.map((subCategory, index) => {
					if (subCategory.isCV) {
						subjectColor = subCategory.subjectColor;
					}

					return (
						<div
							key={`${subCategory.fullName.split(' ').join('')}_${index}`}
							className={subCategoriesStyles.subCategoryColumn}
						>
							<div className={subCategoriesStyles.subCategoryHeader}>
								<a
									onClick={(e) => {
										if (isSimplifiedView && onSubjectChange) {
											e.preventDefault();
											onSubjectChange(subCategory.id);
										}
										if (!isSimplifiedView) {
											e.preventDefault();
											onSubjectSelect(subCategory.id);
										}
									}}
									href={`/measures/${subCategory.id.toLowerCase()}.html`}
									className={`${
										isSearchedPhrase({
											subjectName: subCategory.fullName,
											phrase: searchPhrase,
										})
											? styles.highlightSearchedWord
											: ''
									} ${subCategoriesStyles.subjectNameLevel2} ${
										!isSimplifiedView && selectedSubjects.includes(subCategory.id)
											? `${subCategoriesStyles.selectedSubMeasure} ${subjectParent}`
											: ''
									}`}
								>
									<img
										className={`${subCategoriesStyles.listIcon}`}
										src={`/img/icons/${subCategory.id}.svg`}
										alt={subCategory.fullName}
									/>
									<HighlightText text={subCategory.fullName} phrase={searchPhrase} />
									{!isSimplifiedView && selectedSubjects.includes(subCategory.id) && (
										<span
											className={styles.deselectX}
											onClick={(e) => {
												e.preventDefault();
												e.stopPropagation();
												onSubjectSelect(subCategory.id);
											}}
										>
											<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M9 3L3 9M3 3L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
											</svg>
										</span>
									)}
								</a>
							</div>
							<ul className={`${subCategoriesStyles.subCategoryList} ${subCategoriesStyles.treeContainer}`}>
								{subCategory?.childrens ? (
									<Indicators
										isSimplifiedView={isSimplifiedView}
										indicators={subCategory.childrens}
										subCategoryId={subCategory.uid}
										nestedListsToShow={nestedListsToShow}
										showNestedLists={showNestedLists}
										selectedSubjects={selectedSubjects}
										onSubjectSelect={onSubjectSelect}
										subjectColor={subjectColor}
										subjectParent={subjectParent}
										queryParams={queryParams}
										searchPhrase={searchPhrase}
										onSubjectChange={onSubjectChange}
									/>
								) : null}
							</ul>
						</div>
					);
				})}
			</div>
		</div>
	);
}
